exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-3c30f182] {\n  color: green\n}\n", ""]);

// exports
